<template>
  <div class="flex flex-col gap-2">
    <i18n-t
      keypath="familiarize-yourself-with-spare-parts"
      tag="p"
    >
      <template #sparePartsListLink>
        <CustomLink
          :blank="true"
          :url="sparePartsCatalogUrl"
          class="link link--primary"
        >
          <template #front-icon>
            <span
              class="iconify fa-pro-light--file-arrow-down text-EXPONDO-secondary relative top-1"
            />
          </template>
          <span class="link">{{ $t("consult the spare parts catalogue") }}</span>
        </CustomLink>
      </template>
    </i18n-t>
    <div>
      <CustomButton
        type="secondary"
        @click="openContactForm"
      >
        {{ $t("Order spare parts") }}
      </CustomButton>
    </div>
  </div>
</template>

<script lang="ts">

import { getSparePartsUrl } from '~~/helpers/spareParts/spareParts';

export default defineComponent({
  name: 'SpareParts',

  props: {
    sku: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const { openWebformModal } = useWebformModalStore();

    const openContactForm = (): void => {

      openWebformModal({
        sku: props.sku,
        shouldPrefillFormForSpareParts: true,
      });

    };

    const sparePartsCatalogUrl = computed(() => {

      return getSparePartsUrl(props.sku);
      
    });

    return { openContactForm, sparePartsCatalogUrl };

  },
});

</script>
